import { request } from '../utils';

const SESSION_PWD_KEY = 'lorentz_session_pwd';

/**
 * Credenciais da sessão atual (não persistidas em localStorage).
 */
export const LorentzSession = {
  setPassword(pwd) {
    try {
      if (pwd) sessionStorage.setItem(SESSION_PWD_KEY, pwd);
      else sessionStorage.removeItem(SESSION_PWD_KEY);
    } catch {
      /* ignore */
    }
  },

  getPassword() {
    try {
      return sessionStorage.getItem(SESSION_PWD_KEY) || '';
    } catch {
      return '';
    }
  },

  clear() {
    this.setPassword('');
  }
};

/**
 * Extrai expiração do JWT (ms epoch).
 */
export function parseJwtExpiry(token) {
  if (!token || typeof token !== 'string') return null;
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const payload = JSON.parse(atob(part.replace(/-/g, '+').replace(/_/g, '/')));
    if (payload?.exp) return payload.exp * 1000;
  } catch {
    /* ignore */
  }
  return null;
}

function authEndpoints(apiBaseUrl) {
  const base = (apiBaseUrl || '').replace(/\/$/, '');
  const sep = base.includes('?') ? '&' : '?';
  return [
    `${base}${sep}endpoint=auth&sub=login`,
    `${base}${sep}endpoint=auth/login`,
    `${base}/auth/login`
  ];
}

/**
 * Autentica operador no Supervisor e retorna JWT.
 * Tenta múltiplos formatos de endpoint documentados no stack Lorentz.
 */
export async function authenticateAgent({
  apiBaseUrl,
  username,
  password,
  group
}) {
  const body = {
    username,
    password,
    login: username,
    group: group || undefined
  };

  let lastError;

  for (const endpoint of authEndpoints(apiBaseUrl)) {
    try {
      const res = await request({
        endpoint,
        method: 'POST',
        body,
        retries: 1,
        qdelay: 5
      });

      const token =
        res?.token ||
        res?.data?.token ||
        res?.access_token ||
        res?.data?.access_token;

      if (token) {
        return {
          token,
          agent: res?.agent || res?.data?.agent || {},
          expiresAt: parseJwtExpiry(token)
        };
      }

      if (res?.success === false) {
        lastError = new Error(res?.message || res?.error || 'Login recusado');
      }
    } catch (err) {
      lastError = err;
    }
  }

  throw lastError || new Error('Não foi possível autenticar no Supervisor');
}

/**
 * Renova JWT usando credenciais da sessão.
 */
export async function refreshAgentToken({ apiBaseUrl, username, password, group }) {
  return authenticateAgent({ apiBaseUrl, username, password, group });
}
